import { Drawer } from '@verbit-ai/verbit-ui-library'

import { LanguagesList } from 'src/components/LanguageSelect/LanguagesList'
import { LanguageSelectProps } from 'src/components/LanguageSelect/types'
import { useResponsiveContainer } from 'src/contexts/ResponsiveContainerContext'

import * as S from './styles'

export const LanguageSelectMobile = (props: LanguageSelectProps) => {
    const { isOpen, onClose } = props
    const { containerRef } = useResponsiveContainer()

    return (
        <Drawer isOpen={isOpen} onClose={onClose} placement="bottom" autoFocus={false} portalProps={{ containerRef }}>
            <S.LanguageSelectContainer>
                <S.LanguageSelectTitle>Select language</S.LanguageSelectTitle>
                <LanguagesList />
            </S.LanguageSelectContainer>
        </Drawer>
    )
}
